const DEFAULT_CONFIGS_LINK = `https://api.the.ismaili/Pages_Scripts/webservices/website_environment_data.php`;

export const CONFIGS_LINK = process.env.REACT_APP_CONFIGS_LINK || DEFAULT_CONFIGS_LINK;

export const INITIAL_PAGE_NAME = "home-page";
